import { query2COrders } from "@/apis/cube";
import { queryCustomers as queryIntegrationCustomers } from "@/apis/integration/customer";
import { queryOrders as queryTMSOrders } from "@/apis/tms/order";
import { queryOrders as queryIntegrationOrders } from "@/apis/integration/order";
import {
  CommonTabProps,
  Cube2COrder,
  IntegrationCustomerVo,
  IntegrationOrderStatus,
  IntegrationOrderType,
  TMSOrderVo,
} from "@/types";
import { noCheck } from "@/utils/shared";
import { ArrayParam, StringParam } from "use-query-params";

export const IntegrationOrderPageSearchItems = [
  {
    title: "Customer",
    desc: "customer, input to search",
    span: 1,
    type: "select",
    key: "customerName",
    options: async (nameLike?: string) =>
      queryIntegrationCustomers({ nameLike }).then((res) => res.items),
    dataToOption: (data: IntegrationCustomerVo) => ({
      label: data.name,
      value: data.name,
    }),
    placeHolder: "customer, input to search",
    pageQueryConfig: StringParam,
    validate: noCheck,
  } as const,
  {
    title: "Cube Instruction No.",
    desc: "starts with CION",
    span: 1,
    type: "select",
    key: "cubeOrderId",
    options: async (instructionNumber?: string) =>
      query2COrders({ instructionNumber }).then((res) => res.items),
    dataToOption: (data: Cube2COrder) => ({
      label: data.instruction.instructionNumber,
      value: data.instruction.instructionId,
    }),
    placeHolder: "cube instruction no",
    pageQueryConfig: StringParam,
    validate: noCheck,
  } as const,
  {
    title: "Type",
    desc: "2B or 2C",
    span: 1,
    type: "select",
    key: "type",
    options: [
      { label: "Business", value: IntegrationOrderType.Business },
      { label: "Customer", value: IntegrationOrderType.Customer },
    ],
    placeHolder: "type, input to search",
    pageQueryConfig: StringParam,
    validate: noCheck,
  },
  {
    title: "Customer Order No.",
    desc: "like search",
    span: 1,
    type: "text",
    key: "customerNumberLike",
    placeHolder: "customer order no., input to search",
    inputMode: "text",
    defaultValue: "" as string,
    pageQueryConfig: StringParam,
    validate: noCheck,
  },
  {
    title: "Status",
    desc: "multiple select",
    span: 1,
    type: "select",
    key: "statusList",
    mode: "multiple",
    options: [
      { label: "Created", value: IntegrationOrderStatus.Created },
      { label: "Submitted", value: IntegrationOrderStatus.Submitted },
      { label: "Completed", value: IntegrationOrderStatus.Completed },
      { label: "Deleted", value: IntegrationOrderStatus.Deleted },
      { label: "Acknowledged", value: IntegrationOrderStatus.Acknowledged },
    ],
    placeHolder: "status, select to search",
    pageQueryConfig: ArrayParam,
    validate: noCheck,
  },
];

export const IntegrationOrderPageTabs: CommonTabProps["tabs"] = [
  {
    key: "order",
    label: "Order",
  },
  {
    key: "logs",
    label: "Logs",
  },
];

export async function getIntegrationOrderAssociatedTMSOrder(
  integrationOrderId: number,
): Promise<TMSOrderVo[]> {
  try {
    const integrationOrder = await queryIntegrationOrders({
      id: integrationOrderId,
    });
    if (integrationOrder.items.length === 0) {
      return Promise.reject(new Error("Integration order not found"));
    }
    const cubeOrderNo = integrationOrder.items[0].cubeDeliveryNo;
    if (cubeOrderNo == null) {
      return Promise.reject(new Error("No associated cube order found"));
    }
    const tmsOrder = await queryTMSOrders({
      scanOrderProductCustomerOrderNo: cubeOrderNo,
    });
    if (tmsOrder.items.length === 0) {
      return Promise.reject(new Error("No associated TMS order found"));
    }
    return tmsOrder.items;
  } catch (error) {
    return Promise.reject(error);
  }
}
